@let backgroundImage =
  displayUrl()
    ? 'url(' + displayUrl() + ') center center / ' + size() + ' no-repeat'
    : 'url(/assets/images/placeholders/image-placeholder.svg) center center / auto auto no-repeat';

<div
  class="wrapper"
  [class.bordered]="!borderless()"
  [style]="{
    background: backgroundImage,
    height: dimensions().height,
    width: dimensions().width,
  }"
></div>
